import { render, staticRenderFns } from "./DetailDSPPage.vue?vue&type=template&id=26cb7cfc&scoped=true"
import script from "./DetailDSPPage.vue?vue&type=script&lang=js"
export * from "./DetailDSPPage.vue?vue&type=script&lang=js"
import style0 from "./DetailDSPPage.vue?vue&type=style&index=0&id=26cb7cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cb7cfc",
  null
  
)

export default component.exports